import $ from 'jquery';
import Router from 'biogas/router.js';
import Datatable from 'biogas/datatable.js';
import {numberWithCommas} from 'biogas/clearing.js';

export default (function () {
    var periodid;
    var cid;
    var anlagen = [];
    var anlagenById = {};
    var company;
    var einsptbl;
    var zaehlertbl;
    var Clearing;

    function getAnlagen(cb, cbdata) {
        if (anlagen.length) {
            return cb(null, anlagen, cbdata);
        }
        $.ajax({
            type: "GET",
            url: '/api/v1/companies/' + cid + '/anlagen',                
            dataType: 'json'
        }).done(function (data) {
            if (data === false) {
                var me = $('#einspeisung');
                Clearing.log('Keine Anlagen / Pas d\' installations', me);
            } else {
                anlagen = data;
                for (var i = 0; i < data.length; i++) {
                    anlagenById[data[i].anlageid] = data[i];
                }
                cb(null, data, cbdata);
            }
        }).fail(function (payload) {
            var me = $('#einspeisung');
            if (payload.responseJSON) {
                Clearing.log(payload.responseJSON.message, me);
            } else {
                Clearing.log(payload.responseText, me);
            }
        });
    }
    
    function asel(key, data) {
        return data.anlagename;
    }
    
    function csel(key, data) {
        return data.companyname;
    }
    
    function printamount(key, data) {
        return numberWithCommas(data[key]) + ' kg';
    }

    function printprec(key, data) {
	return round(data[key], 8).toString();
    }

    function round(number, decimalPlaces) {
      if (typeof number == "string") {
            number = parseFloat(number);
      }
      const factorOfTen = Math.pow(10, decimalPlaces);
      return Math.round( number * factorOfTen) / factorOfTen;
    }
    
    function printaequivalent(key, data) {
        var computed;
        switch (data.gastype) {
            case 'SG':
                computed = parseInt(data.amount) * 3.33;
                break;
            case 'H':
                computed = parseInt(data.amount) * 2.613;
                break;
            default:
                computed = parseInt(data.amount) * 1;
                break;
        }
        return numberWithCommas(Math.round(computed)) + ' kg';
    }
    
    function updateAnlage(model, mid, m, value, cb) {
        Clearing.updateElement(model, mid, m, value, function (err, data) {
            if (data.anlageid) {
                Clearing.getGasTypes(function (err, gt) {
                    var td = $('#einspeisung tr[data-id="' + mid + '"] td.gastype');
                    td.attr('data-value', anlagenById[data.anlageid].gastype);
                    td.html(gt[anlagenById[data.anlageid].gastype].value);
                    $('#einspeisung tr[data-id="' + mid + '"] td.gasamount').html(Clearing.printnumber(data.gasamount) + ' kg');
                    Clearing.recomputeTotal($("#einspeise table"));
                });
            }
            cb(null, data);
        });
    }
    
    function updateAmount(model, mid, m, value, cb) {
        Clearing.updateElement(model, mid, m, value, function (err, data) {
            if (err) return cb(err);            
            $('#einspeisung tr[data-id="' + mid + '"] td.gasamount').html(data.gasamount + ' kg');
	    cb(null, data);
        });
    }

    function setupEinspeisungen(baseurl, periodid) {
        
        var model = {
            rowLabel: "setupEinspeisungen",
            patchurl: '/api/v1/companies/' + cid + '/einspeisungen/',
            anlageid: { key: 'anlageid', type: 'select', data: getAnlagen, elemkey: 'anlageid', elemvalue: 'anlagename', update: updateAnlage, template: asel, valCol: 'anlageid', edit: 1 },
            company: { key: 'company', type: 'select', data: function(d,cd) { Clearing.getCompaniesWithEmpty(d, cd); }, elemkey: 'companyid', elemvalue: 'name', update: Clearing.updateElement, template: csel, valCol: 'sellerid', edit: 1 },
            //sellerid: { key: 'company', type: 'select', data: function(d,cd) { Clearing.getCompaniesWithEmpty(d, cd); }, elemkey: 'companyid', elemvalue: 'name', update: Clearing.updateElement, template: csel, valCol: 'sellerid', edit: 1 },
            amount: { key: 'amount', type: 'number', min: 0, update: updateAmount, template: printamount, valCol: 'amount', edit: 1 },
            gasamount: { key: 'gasamount', type: 'number', template: printamount, valCol: 'gasamount' },
            gastype: { key: 'gastype', type: 'select', data: Clearing.getTypes, elemkey: 'key', elemvalue: 'value', update: Clearing.updateElement, valCol: 'gastype', printCol: 'gasname' },
            comment: { key: 'comment', type: 'textarea', update: Clearing.updateElement, valCol: 'comment', edit: 1 },
            actions: { key: 'actions', template: '<img class="delete" src="/images/delete.png">' + $("#saveform").html() },
            empty: { key: 'empty', template: ' ' },
            addEntry: function (me, data, cb) {
                $.ajax({
                    type: "POST",
                    url: '/api/v1/companies/' + cid + '/periods/' + periodid + '/einspeisungen',
                    data: data,                
                    dataType: 'json'
                }).done(function (data) {
                    cb(null, data);
                    Clearing.recomputeTotal($("#einspeise table"));
                }).fail(function (payload) {                    
                    if (payload.responseJSON) {
                        Clearing.log(payload.responseJSON.message, me);
                    } else {
                        Clearing.log(payload.responseText, me);
                    }
                });
            },
            deleteEntry: function (me, id, cb) {
                $.ajax({
                    type: "DELETE",
                    url: '/api/v1/companies/' + cid + '/einspeisungen/' + id,                                    
                    dataType: 'json'
                }).done(function (data) {
                    cb(null, data);
                }).fail(function (payload) {
                    if (payload.responseJSON) {
                        Clearing.log(payload.responseJSON.message, me);
                    } else {
                        Clearing.log(payload.responseText, me);
                    }
                });
            },
            recompute: function () {
                Clearing.recomputeTotal($("#einspeise table"));
            }
        };
        
        var cols = [
            'anlageid',
            'amount',
            'gastype',
            'company',
            //'sellerid',
            'gasamount',
            'comment',
            'actions'            
        ];
        
        var etbl = new Datatable();
        etbl.init("#einspeise table", {
            url: baseurl + '/companies/' + cid + '/periods/' + periodid + '/einspeisungen',           
            bodysel: '.datacontent',
            idcol: 'id',
            columns: cols,
            model: model,
            okbutton: $("#okbutton").html(),
            datahandler: function (data) {
                // called after data loaded                
                Clearing.recomputeTotal($("#einspeise table"));
            }
        });

        return etbl;
    }

    function factreset(key, data) {
        if (data['stdfaktor'] && data['stdfaktor'] > 0) {
            var f = round(data['stdfaktor'], 8 );
            return '<img src="/images/icon_reset.gif" class="factorreset" data-stdvalue="' + f + '"/>';
        } else {
            return '';
        }
    }

    function checkedit(data) {
        if (data.einheit == 'kg') {
            return false;
        }
        return true;
    }

    function setupZaehler(baseurl, periodid) {
        var model = {
            rowLabel: "setupZaehler",
            patchurl: '/api/v1/companies/' + cid + '/productionzaehler/',
            name: { key: 'name', valCol: 'name' },
            nr: { valCol: 'nr' },
            gastype: { key: 'gastype', valCol: 'gastype' },
            einheit: { valCol: 'einheit' },
            standalt: { valCol: 'standalt', cssclass: 'amount', template: Clearing.printnumber, },
            stand: { key: 'stand', type: 'number', min: 0, cssclass: 'amount', update: Clearing.updateElement, template: Clearing.printnumber, valCol: 'stand', edit: 1 },
            diff: { cssclass: 'amount' },
            diffkg: { cssclass: 'amount' },
            factor: { key: 'factor', type: 'number', min: 0, step: 'any', cssclass: 'amount', template: printprec, update: Clearing.updateElement, valCol: 'factor', edit: 1, editable: checkedit },
            factoraction: { key: 'factoraction', template: factreset },
            comment: { key: 'comment', type: 'textarea', update: Clearing.updateElement, valCol: 'comment', edit: 1 },                
            empty: { key: 'empty', template: ' ' },       
            actions: { key: 'actions', template: $("#saveform").html() },         
            recompute: function () {
                Clearing.recomputeZaehler($("#zaehler table"));
            }
        };
        
        var cols = [
            'name', 
            'gastype',           
            'standalt',
            'einheit',
            'stand',
            'einheit',
            'diff',
            'einheit',
            'factor',
            'factoraction',
            'diffkg',
            'comment',
            'actions'
        ];
        
        var tbl = new Datatable();
        tbl.init("#zaehler table", {
            url: baseurl + '/companies/' + cid + '/periods/' + periodid + '/productionzaehler',           
            bodysel: '.datacontent',
            idcol: 'id',
            columns: cols,
            model: model,
            okbutton: $("#okbutton").html(),
            datahandler: function (data) {
                // called after data loaded                
                if (data.length) {
                    $("#zaehler").removeClass('nn');
                    Clearing.recomputeZaehler($("#zaehler table"));
                    $(".factorreset").click(function (e) {
                        var me = $(this);
                        var stdfactor = me.attr('data-stdvalue');
                        if (stdfactor) {
                            var mid = me.parents('tr').attr('data-id');
                            Clearing.updateElement(model, mid, model.factor, stdfactor, function (err) {
                                if (!err) {
                                    var felem = me.parents('tr').find('.factor');
                                    felem.attr('data-value', stdfactor);
                                    felem.html(stdfactor);
                                    model.recompute();
                                }
                            });
                        }
                    });
                }
            }
        });

        return tbl;
    }

    function changePeriod(err, me, ishist) {
        // change of period requested
        var pid;
        if (typeof me == 'number') {
            pid = me;
        } else {
            pid = me.val();
        }
        if (periodid != pid) {
            if (!ishist) {
                Router.hpush(window.location.protocol + "//" + window.location.host + '/' + company + '/produktion/' + pid);
            }
        }
        $('.metatable .period select option[value=' + pid + ']').prop('selected', 'selected');
        periodid = pid;        
        var periods = Clearing.productionperiods();

        var today = new Date();
        today.setDate(today.getDate() - 1);
        var changeuntil = new Date(periods[periodid].changeuntil);
        if ((changeuntil > today) || (periods[periodid].storno)) {
            einsptbl.setEditable(true);
            $('#einspeisung').addClass('editable');
            zaehlertbl.setEditable(true);
        } else {
            einsptbl.setEditable(false);
            $('#einspeisung').removeClass('editable');
            zaehlertbl.setEditable(false);
        }
        einsptbl.setURL('/api/v1/companies/' + cid + '/periods/' + periodid + '/einspeisungen');
        zaehlertbl.setURL('/api/v1/companies/' + cid + '/periods/' + periodid + '/productionzaehler');

        // summary table
        Clearing.getSummaryTable(periodid);
    }

    return {
        init: function (clearing, baseurl, meta) {
            Clearing = clearing;
            Router.hinit(window.location.protocol + "//" + window.location.host + window.location.pathname);
            
            var url = window.location.pathname.split('/');            
            company = url[1];

            // get startup periodid 
            if (url[3]) {
                periodid = parseInt(url[3]);
            } else {
                periodid = parseInt(meta.attr('data-period'));
            }
            cid = meta.attr('data-company');            

            einsptbl = setupEinspeisungen(baseurl, periodid);
            zaehlertbl = setupZaehler(baseurl, periodid);
            
            if (!$("#einspeisung").hasClass('editable')) {
                einsptbl.setEditable(false);
                zaehlertbl.setEditable(false);
            }

            Router.add('/' + company + '/produktion/(\\d+)', function (hist, rt) {
                changePeriod(null, parseInt(rt[1]), true);
            });

            var defid = parseInt(meta.attr('data-period'));

            Router.add('/' + company + '/produktion', function (hist, rt) {
                changePeriod(null, defid, true);
            });  

            Clearing.getPeriods('production', changePeriod, periodid);
        }
    };
})();
